import analytics from "web/script/analytics/analytics";

export function sendAnalyticsEvent(
    label: string,
    isInteraction: boolean,
    productId: string,
    buyOptionId: string | null
): void {
    analytics.event(
        "product_gallery",
        "engagement",
        label,
        !isInteraction, // nonInteraction
        {}, // customData
        "", // subType
        {}, // checkoutData
        [{ product_id: productId, buy_option_id: buyOptionId }], // itemData
        false, // lock
        false // truncate
    );
}
